{
  "guidance": {
    "help": {
      "entry": "المساعدة والجولات الإرشادية",
      "panelTitle": "المساعدة والجولات الإرشادية",
      "intro": "جولات قصيرة لما يمكنك فعله هنا. الجولة تشير وتشرح فقط، ولا تغيّر أي شيء.",
      "thisPage": "أرشدني في هذه الصفحة",
      "thisPageHint": "تشرح هذه الصفحة دون مغادرتها.",
      "guideWith": "أرشدني: {{title}}",
      "toursHeading": "الجولات",
      "none": "لا تتوفر جولة لصلاحياتك بعد.",
      "steps": "خطوات الجولة ({{count}})",
      "status": {
        "notStarted": "لم تبدأ",
        "inProgress": "قيد التقدّم",
        "completed": "مكتملة",
        "running": "قيد التشغيل الآن"
      },
      "start": "ابدأ",
      "continue": "متابعة",
      "restart": "أعِد البدء",
      "startNamed": "ابدأ: {{title}}",
      "continueNamed": "متابعة: {{title}}",
      "restartNamed": "أعِد البدء: {{title}}",
      "browserOnly": "يُحفظ التقدّم في هذا المتصفح فقط.",
      "groups": {
        "workflows": "مسارات عمل موجَّهة",
        "workflowsHint": "خطوة بخطوة خلال مهمة حقيقية. تنفّذ كل خطوة بنفسك، ولا يضغط المرشد أي شيء نيابةً عنك.",
        "oriented": "تعرّف على المكان",
        "explain": "أدلة الشاشات",
        "explainHint": "جولات قصيرة تشرح الشاشة. تشير فقط، ولا تغيّر أي شيء."
      },
      "show": "أظهِر المرشد",
      "showNamed": "أظهِر المرشد: {{title}}",
      "restartNote": "إعادة البدء تبدأ من الخطوة الأولى مجددًا، ولا تتراجع عن أي شيء نفّذته."
    },
    "card": {
      "progress": "الخطوة {{current}} من {{total}}",
      "back": "رجوع",
      "next": "التالي",
      "finish": "إنهاء",
      "close": "إغلاق الجولة",
      "retry": "إعادة المحاولة",
      "commitNote": "لن تنفّذ الجولة هذا نيابةً عنك. أنهِ الجولة، ثم نفّذه بنفسك عندما تكون جاهزًا."
    },
    "pause": {
      "title": "الجولة متوقفة مؤقتًا",
      "missing": "هذا الجزء من الصفحة غير ظاهر الآن، وقد يحتاج إلى بيانات أو صلاحية غير متاحة هنا.",
      "dirty": "في هذه الصفحة تغييرات غير محفوظة، لذلك لن تغادرها الجولة. احفظها أو تراجع عنها، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
      "permission": "لم تعد هذه الجولة متاحة لصلاحياتك.",
      "record": "افتح أولًا السجل الذي تريد العمل عليه، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
      "error": "تعذّر عرض هذه الخطوة. لم يتغيّر شيء في الصفحة. أعد المحاولة أو أغلق الجولة.",
      "leftPage": "تغيّرت الصفحة، لذلك توقفت الجولة مؤقتًا هنا. اختر «متابعة» من المساعدة والجولات الإرشادية متى كنت جاهزًا."
    },
    "invitation": {
      "title": "جديد هنا؟",
      "body": "جولة مدتها دقيقة تعرض أماكن الأشياء، ولا تغيّر شيئًا.",
      "start": "ابدأ الجولة",
      "dismiss": "ليس الآن"
    },
    "tours": {
      "T01": {
        "title": "تعرّف على مساحة العمل",
        "summary": "أين تجد القائمة وعملك وتبديل اللغة والمساعدة.",
        "welcome": {
          "title": "مساحة عملك",
          "body": "تعرض هذه الجولة القصيرة أماكن الأشياء فقط، ولا تفتح أو تحفظ أو ترسل أي شيء نيابةً عنك."
        },
        "navigation": {
          "title": "القائمة",
          "body": "هنا كل ما يتيحه لك دورك. الأقسام غير المتاحة لك لا تظهر أصلًا."
        },
        "bottomNavigation": {
          "title": "التنقل السريع",
          "body": "على الهاتف أو الجهاز اللوحي تجد الأماكن الأكثر استخدامًا أسفل الشاشة، ويفتح «المزيد» القائمة كاملة."
        },
        "yourWork": {
          "title": "عملك",
          "body": "تبدأ لوحة المعلومات بما يحتاج إليك: طلباتك، أو القرارات أو عمليات التسليم التي تنتظرك، أو أرقام منشأتك، بحسب دورك."
        },
        "language": {
          "title": "العربية أو الإنجليزية",
          "body": "بدّل اللغة في أي وقت، ويبقى عملك كما هو."
        },
        "help": {
          "title": "المساعدة والجولات الإرشادية",
          "body": "افتحها متى احتجت إلى جولة. يُحفظ التقدّم في هذا المتصفح فقط."
        }
      },
      "T10": {
        "title": "بوابة المورد",
        "summary": "لمن تورّد، وما يحتاج إلى إجراء منك، وكيف تردّ على الأمر وتسجّل الشحن وترسل الفاتورة.",
        "context": {
          "title": "لمن تورّد",
          "body": "يعرض الشريط العلوي اسم شركتك والمشتري الذي تتعامل معه. كل ما هنا يخص هذا المشتري وحده."
        },
        "home": {
          "title": "ما يحتاج إلى إجراء منك",
          "body": "تعرض الرئيسية ما ينتظرك: أوامر للتأكيد أو الشحن أو الفوترة، وطلبات عروض لتسعيرها. وإن لم يكن هناك شيء، تذكر ذلك."
        },
        "orders": {
          "title": "أوامرك",
          "body": "كل أمر أرسله إليك هذا المشتري، مع إصداره الحالي وما يحتاجه بعد ذلك. افتح الأمر للرد عليه."
        },
        "openOrder": "افتح أمرًا من قائمة أوامرك، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "orderStatus": {
          "title": "هذا الأمر",
          "body": "الإصدار الذي تردّ عليه، ووضع الأمر وردّك والتسليم، كلٌّ منها على حدة. ولا تظهر الفوترة هنا."
        },
        "orderAnswer": {
          "title": "ردّك",
          "body": "أكّد هذا الإصدار، أو حدّد تاريخ التسليم، أو أبلغ عن نقص بندًا بندًا، أو اطرح سؤالًا، أو ارفض مع ذكر السبب. ولا ترسل الجولة شيئًا."
        },
        "orderDispatch": {
          "title": "تسجيل شحنة",
          "body": "أبلغ المشتري بخروج الشحنة مع رقم إشعار التسليم الخاص بها. يمكنك تسجيل أكثر من شحنة، ولا يلزم تأكيد الأمر قبلها."
        },
        "orderInvoice": {
          "title": "فواتيرك لهذا الأمر",
          "body": "أرسل الفاتورة التي أصدرتها بصيغة PDF. تُحفظ دليلًا مقابل إصدار الأمر، وليست طلب سداد."
        }
      },
      "T12": {
        "title": "عمليات المنصة",
        "summary": "التنقل والأرقام، والمنشآت، والمسؤول الأول للمنشأة وأقسامها.",
        "navigation": {
          "title": "التنقل",
          "body": "نظرة عامة والمنشآت، ثم أمان تسجيل الدخول بعد إعداد التحقق بخطوتين."
        },
        "metrics": {
          "title": "أرقام المنصة",
          "body": "أعداد عبر جميع المنشآت، للاطلاع فقط. لا شيء هنا يصل إلى مشتريات أي عميل."
        },
        "definitions": {
          "title": "معنى الأرقام",
          "body": "كيف يُحتسب كل رقم، ليقرأه الجميع بالطريقة نفسها."
        },
        "organisations": {
          "title": "المنشآت",
          "body": "كل منشأة عميلة مع حالتها. ابحث بالاسم أو ضيّق القائمة حسب الحالة، وتبقى التصفية في عنوان الصفحة. افتح إحداها لترى مسؤولها وسعتها وإعدادها."
        },
        "openOrganisation": "افتح منشأة من القائمة، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "create": {
          "title": "إنشاء منشأة",
          "body": "يفتح النموذج الذي يُنشئ المنشأة ويدعو مسؤولها الأول. لا يُعرض عليك رابط الدعوة أبدًا، ولا تُنشئ الجولة شيئًا."
        },
        "administrator": {
          "title": "المسؤول الأول",
          "body": "هل فعّل المسؤول الأول حسابه، ومتى تنتهي الدعوة. «إعادة إرسال الدعوة»، إن أتاحها دورك، ترسل رابطًا جديدًا ويتوقف الرابط السابق، ولا تضغطها الجولة."
        },
        "sections": {
          "title": "أقسام المنشأة",
          "body": "الاشتراك والسعة: الخطة والتجربة وسعة وحدات الشراء. الإعداد: خطوات الإعداد المنجزة حتى الآن. السجل، إن أتاحه دورك: الأحداث التجارية. ولا تُدار هنا الفوترة والخصومات وتغيير الخطط."
        }
      }
    },
    "coaches": {
      "actions": {
        "ready": "أنا جاهز",
        "pause": "إيقاف مؤقت",
        "close": "إغلاق المرشد",
        "skip": "تخطَّ الشرح",
        "return": "العودة",
        "returnTo": "العودة إلى {{page}}"
      },
      "handoff": {
        "title": "ستنفّذ الآن الإجراء الفعلي بنفسك",
        "note": "لن يضغطه المرشد نيابةً عنك، ولن ينتقل إلا بعد أن تؤكد الصفحة ما حدث."
      },
      "dock": {
        "waiting": "بانتظارك. لا يفعل المرشد شيئًا من تلقاء نفسه.",
        "pending": "ترسل الصفحة ما نفّذته. انتظر ردّها.",
        "confirming": "بانتظار أن تعرض الصفحة النتيجة.",
        "failed": "لم يتم ذلك. توضّح الصفحة السبب. لم يغيّر المرشد شيئًا.",
        "away": "غادرت هذه الخطوة. عُد إلى {{page}} للمتابعة.",
        "awayNoReturn": "غادرت هذه الخطوة. عُد إلى {{page}} للمتابعة؛ المرشد بانتظارك.",
        "awayUnnamed": "غادرت هذه الخطوة. عُد للمتابعة؛ المرشد بانتظارك.",
        "field": "أكمِل الحقل الذي تعمل فيه. يتابع المرشد عندما تغادره.",
        "minimise": "تصغير المرشد",
        "show": "أظهِر المرشد: {{context}}"
      },
      "pause": {
        "title": "المرشد متوقف مؤقتًا",
        "missing": "هذا الجزء من الصفحة غير ظاهر الآن، وقد يحتاج إلى بيانات أو صلاحية غير متاحة هنا. لم يتغيّر شيء.",
        "permission": "لم يعد هذا المرشد متاحًا لصلاحياتك.",
        "error": "تعذّر عرض هذه الخطوة. لم يتغيّر شيء في الصفحة. أعد المحاولة أو أوقف المرشد مؤقتًا."
      },
      "resume": {
        "title": "متابعة «{{title}}»؟",
        "body": "كنت في الخطوة {{current}} من {{total}}. يتحقق المرشد مما تعرضه الصفحة الآن ولا يفترض شيئًا.",
        "later": "ليس الآن"
      },
      "pages": {
        "tenant": {
          "catalogue": "الكتالوج",
          "catalogue-item": "الصنف",
          "cart": "سلتك",
          "request": "طلبك",
          "approvals": "قائمة الاعتمادات",
          "approval": "الطلب المسند",
          "receiving": "قائمة الاستلام",
          "receive": "نموذج الاستلام"
        },
        "vendor": {
          "orders": "أوامرك",
          "order": "أمر الشراء",
          "rfqs": "طلبات التسعير",
          "rfq": "طلب التسعير"
        },
        "platform": {
          "organisations": "المؤسسات",
          "organisation-new": "نموذج الإنشاء"
        }
      },
      "C01": {
        "title": "أنشئ طلبك الأول",
        "summary": "من الكتالوج إلى طلب مُرسَل، خطوة بخطوة. تنفّذ كل خطوة بنفسك، ويرشدك المرشد إلى الطريق.",
        "welcome": {
          "title": "أنشئ طلبك الأول",
          "body": "يرافقك هذا المرشد من الكتالوج حتى إرسال الطلب. أنت من يختار ويضيف ويراجع ويرسل، بأزرار الصفحة نفسها. المرشد يدلّك على الطريق فقط: لا يضغط أي شيء ولا يغيّر بياناتك."
        },
        "search": {
          "title": "ابحث عن صنف معتمد",
          "body": "ابحث باسم الصنف أو رمزه، أو ضيّق القائمة. الصنف الذي يمكنك طلبه يعرض سعره المتفق عليه، والصنف الذي لا يمكنك طلبه يوضّح السبب."
        },
        "openItem": {
          "title": "افتح صنفًا",
          "body": "اختر اسم صنف يمكنك طلبه لترى شروطه."
        },
        "terms": {
          "title": "السعر والشروط المتفق عليها",
          "body": "السعر والمورّد والضريبة والحد الأدنى للطلب مأخوذة من الاتفاقية المعتمدة لوحدة الشراء الخاصة بك. لا يمكنك تغييرها هنا."
        },
        "quantity": {
          "title": "اختر الكمية",
          "body": "أدخل الكمية التي تحتاجها بوحدة الطلب المعروضة. تبدأ بأصغر كمية تسمح بها الاتفاقية."
        },
        "add": {
          "title": "أضف الصنف إلى سلتك",
          "body": "اختر «أضف إلى السلة» بجانب الكمية.",
          "consequence": "يضع هذا الصنف في سلتك. لا يُرسَل شيء للاعتماد بعد، ولا تُحجَز أي ميزانية.",
          "waiting": "اختر «أضف إلى السلة» متى كنت جاهزًا. ينتظر المرشد تأكيد الصفحة.",
          "disabled": "«أضف إلى السلة» غير متاح الآن. أدخل الكمية أولًا."
        },
        "openCart": {
          "title": "افتح سلتك",
          "body": "أكدت الصفحة أن الصنف أصبح في سلتك. اختر «افتح السلة» في رسالة التأكيد، أو «السلة» في القائمة."
        },
        "lines": {
          "title": "سلتك",
          "body": "كل بند بسعره المتفق عليه وكميته. يمكنك تغيير الكمية أو حذف بند؛ يُحفَظ التغيير عند مغادرة الحقل."
        },
        "details": {
          "title": "متى ولماذا",
          "body": "حدّد التاريخ الذي تحتاجه فيه وسبب العمل. يقرؤهما المعتمِدون عند اتخاذ القرار."
        },
        "budget": {
          "title": "الميزانية",
          "body": "ما سيستخدمه هذا الطلب من ميزانيتك كما يحسبه الخادم. لا يُحجَز شيء حتى ترسل الطلب.",
          "absent": "لا يظهر رقم ميزانية لهذه السلة. حين تنطبق ميزانية، تعرض الصفحة هنا ما سيستخدمه الطلب منها."
        },
        "review": {
          "title": "المراجعة والإرسال",
          "body": "اختر «مراجعة وإرسال». تتحقق الصفحة من سلتك مجددًا، ولا يغيّر هذا شيئًا."
        },
        "controls": {
          "title": "ضوابط الشراء",
          "body": "ما أعاد الخادم التحقق منه: أي استثناء من القواعد، وأي ما يمنع إرسال هذا الطلب."
        },
        "route": {
          "title": "مسار الاعتماد المتوقع",
          "body": "من يجب أن يعتمد هذا الطلب وفق قواعد منظمتك، كما يتوقعه الخادم الآن."
        },
        "submit": {
          "title": "أرسل طلبك",
          "body": "اختر «إرسال الطلب» في نهاية المراجعة.",
          "waiting": "اختر «إرسال الطلب» متى كنت جاهزًا. ينتظر المرشد تأكيد الصفحة.",
          "disabled": "«إرسال الطلب» غير متاح: توضّح ضوابط الشراء في هذه الصفحة السبب. عدّل سلتك ثم راجعها مجددًا."
        },
        "status": {
          "title": "أين وصل طلبك",
          "body": "هذه هي الحالة التي سجّلها الخادم لطلبك، وتتغيّر مع تقدّم الطلب."
        },
        "nextAction": {
          "title": "ما الخطوة التالية",
          "body": "ما الذي يحدث بعد ذلك، ومن لديه طلبك الآن."
        },
        "approvers": {
          "title": "المعتمِدون",
          "body": "كل مستوى اعتماد، ومن يتولاه، وأين وصل طلبك.",
          "absent": "لا يظهر مستوى اعتماد لهذا الطلب. توضّح حالته ما حدث له."
        },
        "finish": {
          "title": "هذه هي الرحلة كاملة",
          "body": "أنشأت طلبًا من الكتالوج وتابعته حتى صفحته. ستجده مجددًا في «طلباتي»."
        }
      },
      "C02": {
        "title": "مراجعة طلب",
        "summary": "راجع طلباً مسنداً إليك واتخذ القرار من أزرار الصفحة ثم اقرأ النتيجة المسجلة.",
        "welcome": {
          "title": "راجع العمل المسند إليك",
          "body": "اختر طلباً مخولاً لك اتخاذ القرار بشأنه. لا يختار المساعد طلباً ولا يتخذ قراراً."
        },
        "open": {
          "title": "افتح طلباً",
          "body": "افتح طلباً مسنداً إليك. يوضح العمل بالتفويض صاحب الصلاحية. إذا كانت القائمة فارغة فتوقف مؤقتاً وعد لاحقاً."
        },
        "lines": {
          "title": "اقرأ الأصناف المطلوبة",
          "body": "تحقق من مقدم الطلب والكميات والأسعار والتفاصيل الداعمة قبل اتخاذ القرار."
        },
        "budget": {
          "title": "تحقق من الميزانية",
          "body": "اقرأ وضع الميزانية والاستثناءات التي يعرضها الخادم. لا يمنح التحذير صلاحية تجاوز السياسة."
        },
        "policy": {
          "title": "اقرأ سبب إسناد الطلب إليك",
          "body": "راجع استثناءات السياسة والتأخير وصاحب الاعتماد الحالي. تختلف آثار الاعتماد والاعتماد الجزئية والإعادة والرفض."
        },
        "decide-handoff": {
          "title": "اتخذ قرارك",
          "body": "ستنفذ الآن الإجراء الفعلي. اختر القرار المناسب وأكمل تأكيده مع السبب المطلوب. يسجل الخادم قرارك.",
          "consequence": "ستنفذ الآن الإجراء الفعلي. اختر القرار المناسب وأكمل تأكيده مع السبب المطلوب. يسجل الخادم قرارك."
        },
        "decide": {
          "title": "بانتظار قرارك",
          "body": "استخدم أزرار القرار في الصفحة. يبقى هذا الجزء عند رفض القرار؛ عالج المشكلة التي توضحها الصفحة."
        },
        "result": {
          "title": "اقرأ النتيجة المسجلة",
          "body": "توضح النتيجة القرار وحالة الطلب الحالية. افتح الطلب لقراءة سجله عند الحاجة؛ لا تصدر الاعتماد أمر شراء."
        },
        "finish": {
          "title": "اكتملت المراجعة",
          "body": "راجعت النتيجة المسجلة لدى الخادم. ينهي هذا الزر المساعد فقط."
        }
      },
      "C05": {
        "title": "تسجيل استلام",
        "summary": "تحقق من الكميات المتبقية وسجل ما وصل ثم راجع سجل الاستلام.",
        "welcome": {
          "title": "اختر عملية استلام",
          "body": "اختر أمراً من قائمة الاستلام. تسجل دليلاً على التسليم الفعلي؛ لا ينفذ ذلك دفعة مالية أو يحدّث دفتر مخزون."
        },
        "open": {
          "title": "افتح عملية الاستلام",
          "body": "افتح الأمر الذي تستلمه. تعني القائمة الفارغة عدم وجود استلام متاح ضمن صلاحياتك."
        },
        "facts": {
          "title": "تحقق من تفاصيل التسليم",
          "body": "طابق المورد ونسخة الأمر وبيانات الإرسال مع التسليم الموجود لديك."
        },
        "lines": {
          "title": "أدخل ما وصل",
          "body": "قارن الكميات المطلوبة والمستلمة والمتبقية. أدخل الكميات المسلمة والمقبولة للاستلام الجزئي واشرح النقص أو التلف أو الأصناف غير المطابقة."
        },
        "details": {
          "title": "أضف دليل التسليم",
          "body": "أضف مرجع إشعار التسليم والملاحظات إن وجدت. استخدم خيار وصول كل شيء بصورة صحيحة فقط إذا وصلت جميع الأصناف المتبقية بهذه الصورة."
        },
        "record-handoff": {
          "title": "سجل التسليم الفعلي",
          "body": "ستنفذ الآن الإجراء الفعلي. اضغط زر الاستلام المعتاد بعد مراجعة مدخلاتك. يسجل ذلك دليل الاستلام ويغير الكميات المستلمة والمتبقية.",
          "consequence": "ستنفذ الآن الإجراء الفعلي. اضغط زر الاستلام المعتاد بعد مراجعة مدخلاتك. يسجل ذلك دليل الاستلام ويغير الكميات المستلمة والمتبقية."
        },
        "record": {
          "title": "بانتظار تسجيل الاستلام",
          "body": "استخدم زر الاستلام في الصفحة. يبقى هذا الجزء حتى معالجة أخطاء التحقق أو رفض الخادم."
        },
        "history": {
          "title": "راجع سجل الاستلام",
          "body": "تحقق من الاستلام الجديد والاستثناءات. يبقى نقص التسليم مستحقاً حتى يسجل مشترٍ مخول قرار إغلاق النقص بصورة منفصلة."
        },
        "finish": {
          "title": "تمت مراجعة الاستلام",
          "body": "يمثل تأكيد الاستلام وسجله الدليل. ينهي هذا الزر المساعد فقط."
        }
      },
      "C07": {
        "title": "الرد على طلب تسعير",
        "summary": "اقرأ حاجة المشتري وأدخل عرضك ثم أرسله بنفسك.",
        "welcome": {
          "title": "اختر طلب تسعير",
          "body": "اختر طلب تسعير مفتوحاً لهذا المشتري. لا يختار المساعد مشترياً أو مورداً أو سعراً أو رداً نيابة عنك."
        },
        "open": {
          "title": "افتح دعوة",
          "body": "افتح طلب تسعير دُعيت للرد عليه. تحقق من أن موعد الرد لم ينتهِ."
        },
        "requirement": {
          "title": "اقرأ المتطلبات",
          "body": "تحقق من الكميات والوحدات والموعد وشروط المشتري. عرضك دليل لاتخاذ قرار المشتري وليس أمر شراء."
        },
        "offer": {
          "title": "أدخل العرض",
          "body": "أدخل الأسعار والضريبة والصلاحية والحد الأدنى للطلب ومدة التوريد والتوفر. استخدم شروطك المقترحة الفعلية."
        },
        "documents": {
          "title": "المستندات الداعمة",
          "body": "إذا اخترت رفع مستند فإن الصفحة تنفذ رفعاً فعلياً. راجع المرفقات والعرض الحالي قبل الإرسال."
        },
        "send-handoff": {
          "title": "أرسل عرضك",
          "body": "ستنفذ الآن الإجراء الفعلي. اضغط زر الإرسال في الصفحة. يتلقى المشتري هذا العرض أو تعديله؛ لا يرسل المساعد أي شيء.",
          "consequence": "ستنفذ الآن الإجراء الفعلي. اضغط زر الإرسال في الصفحة. يتلقى المشتري هذا العرض أو تعديله؛ لا يرسل المساعد أي شيء."
        },
        "send": {
          "title": "بانتظار عرضك",
          "body": "عالج أي خطأ تحقق أو رفض بسبب الموعد في الصفحة. يتابع المساعد فقط بعد نجاح الإرسال وتحديث حالة الدعوة."
        },
        "result": {
          "title": "تحقق من العرض المسجل",
          "body": "اقرأ العرض المسجل وحالته. لا يعني إرسال العرض ترسية؛ يتخذ المشتري قراره بصورة منفصلة."
        },
        "finish": {
          "title": "تمت مراجعة العرض",
          "body": "أرسلت العرض بإجرائك أنت. ينهي هذا الزر المساعد فقط."
        }
      },
      "C06": {
        "title": "الرد على أمر شراء",
        "summary": "أكد نسخة أمر الشراء الحالية وسجل الإرسال ثم راجع النتيجة.",
        "welcome": {
          "title": "اختر أمراً بانتظار التأكيد",
          "body": "اختر أمراً حالياً يمكنك تأكيده وإرساله. للاستفسار أو التوفر الجزئي أو الرفض استخدم نموذج الرد في الصفحة وتوقف مؤقتاً عن هذا المسار."
        },
        "open": {
          "title": "افتح النسخة الحالية",
          "body": "افتح الأمر وتحقق من أنه يحتاج إلى تأكيدك. لا يفتح المساعد رابط المستند الذي قد يسجل حدث تدقيق."
        },
        "version": {
          "title": "اقرأ الحالات المنفصلة",
          "body": "دورة الأمر وردك والتنفيذ حالات منفصلة. تحقق من النسخة وأي إشعار لإعادة التأكيد قبل الرد."
        },
        "lines": {
          "title": "راجع التزامك",
          "body": "راجع الكميات والأسعار. استخدم نموذج الرد إذا احتجت إلى تاريخ تسليم أو استفسار أو توفر جزئي أو رفض مع سبب."
        },
        "confirm-handoff": {
          "title": "أكد هذه النسخة",
          "body": "ستنفذ الآن الإجراء الفعلي. اضغط تأكيد هذه النسخة فقط إذا استطعت تنفيذها. يسجل ذلك إقرارك بهذه النسخة من الأمر.",
          "consequence": "ستنفذ الآن الإجراء الفعلي. اضغط تأكيد هذه النسخة فقط إذا استطعت تنفيذها. يسجل ذلك إقرارك بهذه النسخة من الأمر."
        },
        "confirm": {
          "title": "بانتظار التأكيد",
          "body": "توضح الصفحة تأكيد الخادم. إذا لم يتوفر التأكيد فتوقف مؤقتاً واستخدم الرد المناسب في الصفحة."
        },
        "dispatch-handoff": {
          "title": "سجل إرسالاً فعلياً",
          "body": "ستنفذ الآن الإجراء الفعلي. أدخل مرجع إشعار التسليم وتاريخ الإرسال ثم استخدم زر الإرسال في الصفحة بعد مغادرة الشحنة فقط. يسجل ذلك دليل الإرسال.",
          "consequence": "ستنفذ الآن الإجراء الفعلي. أدخل مرجع إشعار التسليم وتاريخ الإرسال ثم استخدم زر الإرسال في الصفحة بعد مغادرة الشحنة فقط. يسجل ذلك دليل الإرسال."
        },
        "dispatch": {
          "title": "بانتظار دليل الإرسال",
          "body": "استخدم نموذج الإرسال بنفسك. ينتظر المساعد تأكيد تسجيله ولا يتوقع حالة تسليم."
        },
        "result": {
          "title": "اقرأ نتيجة الإرسال",
          "body": "الإرسال ليس استلاماً أو فاتورة. يسجل المشتري ما وصل وتُرسل الفواتير بصورة منفصلة حيث يسمح بذلك."
        },
        "finish": {
          "title": "تمت مراجعة الرد على الأمر",
          "body": "تحقق من حالات الأمر المحدثة. ينهي هذا الزر المساعد فقط."
        }
      },
      "C08": {
        "title": "إنشاء مؤسسة",
        "summary": "أنشئ مؤسسة من النموذج المسموح ثم تحقق من حالة دعوة مسؤولها.",
        "welcome": {
          "title": "أنشئ المؤسسة بعناية",
          "body": "ينشئ هذا المسار مؤسسة ودعوة مسؤول فعليتين. استخدم بيانات اصطناعية للعرض فقط. لا يتجاوز المساعد صلاحياتك أو المصادقة الثنائية."
        },
        "open": {
          "title": "افتح نموذج الإنشاء",
          "body": "استخدم إنشاء مؤسسة بنفسك. لا يفتح المساعد نموذج إدخال تلقائياً."
        },
        "details": {
          "title": "راجع المؤسسة والمسؤول",
          "body": "راجع أسماء المؤسسة ومعرفها الفريد والسياق التجاري الذي يدعمه النموذج واسم المسؤول الأول وبريده الإلكتروني."
        },
        "create-handoff": {
          "title": "أنشئ المؤسسة وأرسل الدعوة",
          "body": "ستنفذ الآن الإجراء الفعلي. استخدم زر الإنشاء المعتاد بعد مراجعة التفاصيل. ينشئ ذلك مؤسسة ويحاول إرسال دعوة مسؤولها.",
          "consequence": "ستنفذ الآن الإجراء الفعلي. استخدم زر الإنشاء المعتاد بعد مراجعة التفاصيل. ينشئ ذلك مؤسسة ويحاول إرسال دعوة مسؤولها."
        },
        "create": {
          "title": "بانتظار النتيجة المسجلة",
          "body": "يبقي الرفض هذا الجزء وقيم النموذج. يتابع المساعد فقط عندما يعيد الخادم نتيجة الإنشاء."
        },
        "result": {
          "title": "تحقق من الإرسال والجاهزية",
          "body": "اقرأ حالة إرسال الدعوة. لا يعني تسليمها لخدمة البريد تفعيل الحساب أو وصولها. افتح تفاصيل المؤسسة للتحقق من الجاهزية وتفعيل المسؤول."
        },
        "finish": {
          "title": "تمت مراجعة نتيجة الإنشاء",
          "body": "تمثل نتيجة الخادم الدليل. ينهي هذا الزر المساعد فقط ولا يفعّل حساب المسؤول."
        }
      }
    }
  }
}
